import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.km4};
  `}
`;

export const Label = styled.label`
  ${({ theme: { color, font } }) => css`
    color: ${color.text.neutral.strong};
    font-weight: ${font.weight.bold};
    font-size: ${font.size.m2};
  `}
`;

export const ButtonsContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    gap: ${spacing.km10};
  `}
`;
